// ** Third Party Components
import styled, { css } from "styled-components";

// ####################################################

export const StyledAttachmentPreviewContainer = styled("div")`
	position: relative;
	display: block;
	z-index: 1;
	width: 100%;
	margin: 0 0 0.25rem 0;
	min-height: 90px;
	background-color: var(--dz-ref-color-gray500);
	${({ cursorPointer }) =>
		cursorPointer &&
		css`
			cursor: pointer;
		`};

	${({ $customPadding }) =>
		$customPadding &&
		css`
			padding: ${$customPadding};
		`};
`;

// ####################################################
